import { SagaIterator } from 'redux-saga';
import { App } from '@ps20-frontend/frontend-models';
import { call, select } from '@redux-saga/core/effects'; // NOSONAR
import cloneDeep from 'lodash/cloneDeep';
import { GlobalAction, GlobalActions } from '../global-actions';
import { GlobalPut } from '../global-put/global-put';
import { AngebotsId } from '../payload-models';

interface SnapshotableState {
  angebotsId?: string;
}

export class SnapshotManager<T extends SnapshotableState> {
  public snapshots: T[] = [];

  constructor(private readonly appId: App) {
    this.createSnapshot = this.createSnapshot.bind(this);
    this.restoreSnapshot = this.restoreSnapshot.bind(this);
  }

  *createSnapshot(action: GlobalAction<AngebotsId>): SagaIterator {
    const actionPayload = action.payload;
    const state: T = yield select();

    if (actionPayload.appId !== this.appId || actionPayload.angebotsId !== state.angebotsId) {
      return;
    }

    const storedSnapshot = this.snapshots.find(
      snapshot => snapshot.angebotsId === actionPayload.angebotsId,
    );
    const createdSnapshot = cloneDeep(state);

    if (!storedSnapshot) {
      this.snapshots.push(createdSnapshot);
    } else {
      this.snapshots = this.snapshots.map(snapshot =>
        snapshot === storedSnapshot ? createdSnapshot : snapshot,
      );
    }

    yield call(
      GlobalPut.getInstance().put,
      new GlobalActions().stateSnapshotCreated(actionPayload.appId, actionPayload.angebotsId),
    );
  }

  *restoreSnapshot(action: GlobalAction<AngebotsId>): SagaIterator {
    const actionPayload = action.payload;
    const state: T = yield select();

    if (actionPayload.appId !== this.appId || actionPayload.angebotsId !== state.angebotsId) {
      return;
    }

    const snapshot = this.snapshots.find(
      snapshot => snapshot.angebotsId === actionPayload.angebotsId,
    );

    if (!snapshot) {
      yield call(
        GlobalPut.getInstance().put,
        new GlobalActions().logError(this.appId, `Snapshot ist ${snapshot}.`),
      );
      return yield call(GlobalPut.getInstance().put, new GlobalActions().errorPageRequested());
    }

    yield call(
      GlobalPut.getInstance().put,
      new GlobalActions().replaceState(snapshot, this.appId, state.angebotsId),
    );
    yield call(
      GlobalPut.getInstance().put,
      new GlobalActions().restoreStateSnapshotFinished(this.appId),
    );
  }
}
